module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Arrow-from-bottom-164605441aac6974dbe5d692d322ee9c.svg";